import apiempresaweb from '@/services/api-varejoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find({ dispatch }, {
      where, ...params
    } = {}) {
      console.log(params, where);

      dispatch('scroll/count', { where, ...params, tabela: 'cliente' }, { root: true });

      const [{ data }] = await Promise.all([
        apiempresaweb.get('cliente', { params: { ...where, ...params } }),
      ]);
      // commit('prevenda/SET_PREVENDA_NOMECLIENTE', data[0]?.clinome, { root: true });
      return data;
    },

    async findById({ commit }, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get('cliente', { params: { ...where, ...params } }),
      ]);
      commit('prevenda/SET_PREVENDA_NOMECLIENTE', data[0]?.clinome, { root: true });
      return data;
    },

    async findLimitado(_, {
      where, ...params
    } = {}) {
      const { data } = await apiempresaweb.get('cliente/limitado', { params: { ...where, ...params } });
      return data.data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
